import { createContext, useEffect } from "react";
import { create } from "zustand";

/* ───────────────────────────── The screen's chrome ───────────────────────────── */

export type Chrome = {
  title: string;
  sub?: string | null;
  /** Where the back arrow goes. Absent on the tab screens. */
  back?: string | null;
  /** A screen that commits something: the tabs hide and its action bar shows. */
  commit?: boolean;
};

export const useChrome = create<Chrome & { set: (c: Chrome) => void }>((set) => ({ title: "", set: (c) => set({ title: c.title, sub: c.sub ?? null, back: c.back ?? null, commit: !!c.commit }) }));

/** Declare the screen: the top bar's title and sub-line, the back arrow, and whether tabs show. `<title>` is the screen name only. */
export function useStaffScreen(c: Chrome) {
  const set = useChrome((s) => s.set);
  useEffect(() => {
    set(c);
    document.title = c.title || "Kathkuni";
  }, [set, c.title, c.sub, c.back, c.commit]); // eslint-disable-line react-hooks/exhaustive-deps
}

/** The shell's slot for the action bar, handed down once it is in the DOM. */
export const ActionSlot = createContext<HTMLElement | null>(null);
